import React from "react";
type Props = {
  title: string;
  description: string;
  headerClassName?: string;
  topClassName?: string;
  titleMbClassName?: string;
};
export const PageHeader: React.SFC<Props> = ({
  title,
  description,
  children,
  topClassName,
  headerClassName,
  titleMbClassName,
}) => {
  return (
    <div className={topClassName}>
      {title && (
        <>
          <div className={`${headerClassName} ${titleMbClassName} font-weight-bold`}>
            {title}
          </div>
          <div className="h6 text-muted">
            {description}
          </div>
        </>
      )}
      {children}
    </div>
  );
};
PageHeader.defaultProps = {
  headerClassName: "h2",
  topClassName: "p-4",
  titleMbClassName: "mb-4",
};
export default PageHeader;
